import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Phone, Mail, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" itemScope itemType="https://schema.org/Physiotherapy">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">
              <div className="logo-icon">
                <Activity size={20} />
              </div>
              <div className="logo-text">RV <span>Physio</span></div>
            </div>
            <p itemProp="description">Leading physiotherapy clinic in Greater Noida offering expert pain relief, rehabilitation, and wellness programs. Your recovery is our mission.</p>
          </div>

          <div>
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/treatments">Treatments</Link></li>
            </ul>
          </div>

          <div>
            <h4>Our Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Back Pain Treatment</Link></li>
              <li><Link to="/services">Sports Injury Rehab</Link></li>
              <li><Link to="/services">Stroke Rehabilitation</Link></li>
              <li><Link to="/services">Joint Pain Therapy</Link></li>
            </ul>
          </div>

          <div itemScope itemType="https://schema.org/LocalBusiness">
            <h4>Contact Info</h4>
            <ul className="footer-links">
              <li>
                <a href="tel:+917048944596" itemProp="telephone">
                  <Phone size={14} /> +91 70489 44596
                </a>
              </li>
              <li>
                <a href="mailto:contact@rvtechnologies.net.in" itemProp="email">
                  <Mail size={14} /> contact@rvtechnologies.net.in
                </a>
              </li>
              <li>
                <span itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                  <a href="#">
                    <MapPin size={14} /> 
                    <span itemProp="streetAddress">Tower T3, 7th Floor, 739, Sector Techzone-IV</span>, 
                    <span itemProp="addressLocality"> Greater Noida (West)</span>, 
                    <span itemProp="addressRegion"> GautamBudh Nagar, UP</span> 
                    <span itemProp="postalCode"> 201306</span>
                  </a>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 RV Physio Therapy. All Rights Reserved. Powered by RV Technologies.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
